var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.timezones}})
}
var staticRenderFns = []

export { render, staticRenderFns }